import PropTypes from "prop-types";
import React from "react";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import Recensione from "../Recensioni/Recensione";

const ProductDescriptionTab = ({ spaceBottomClass, productFullDesc, product }) => {
  try {
    if (product.reviews == undefined) {
      product.reviews = [];
      product.reviews[0] = {};
      //console.log(product.reviews.length);
    }
  }
  catch (err) {

  }
  return (
    <div className={`description-review-area ${spaceBottomClass}`}>
      <div className="container">
        <div className="description-review-wrapper">
          <Tab.Container defaultActiveKey="productDescription">
            <Nav variant="pills" className="description-review-topbar">
              {/*<Nav.Item>
                <Nav.Link eventKey="additionalInfo">
                  Informazioni Aggiuntive
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="productDescription">Descrizione</Nav.Link>
              </Nav.Item>*/}
              {global.aziendaID == 1 ? <Nav.Item>
                {(product?.reviews && product?.reviews?.length > 0) ? <Nav.Link eventKey="productReviews">Recensioni({product.reviews.length - 1})
                </Nav.Link> :
                  <Nav.Link eventKey="productReviews">Recensioni</Nav.Link>}
              </Nav.Item> : null}
            </Nav>
            <Tab.Content className="description-review-bottom">
              <Tab.Pane eventKey="additionalInfo">
                <div className="product-anotherinfo-wrapper">
                  <ul>
                    <li>
                      <span>Weight</span> 400 g
                    </li>
                    <li>
                      <span>Dimensions</span>10 x 10 x 15 cm{" "}
                    </li>
                    <li>
                      <span>Materials</span> 60% cotton, 40% polyester
                    </li>
                    <li>
                      <span>Other Info</span> American heirloom jean shorts pug
                      seitan letterpress
                    </li>
                  </ul>
                </div>
              </Tab.Pane>
              <Tab.Pane eventKey="productDescription">
                {productFullDesc}
              </Tab.Pane>
              <Tab.Pane eventKey="productReviews">
                <Recensione recensioni={product.reviews} IDArt={product.id} ></Recensione>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      </div>
    </div>
  );
};

ProductDescriptionTab.propTypes = {
  productFullDesc: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  product: PropTypes.object
};

export default ProductDescriptionTab;
